// components/ModalDialog.js
import React from 'react';
import { useState } from 'react';
import './ModalDialog.css'; // Use your existing dialog styles
import './../spinner.css';
import { toPdf_pages, toPdfAuto } from './toPdf';
import EmailDialog from '../records/EmailDialog';

const ModalDialog = ({ show, onClose, title, children, quoteId = null }) => {
  if (!show) return null;
  const [isLoading, setIsLoading] = useState(false);

  //email dialog
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isViewDetailsVisible, setIsViewDetailsVisible] = useState(true);


  const handleSendEmail = async (recipient) => {
    setShowEmailDialog(true); 
    setIsViewDetailsVisible(false);
  };
  const handlePdfDownload = async () => {
    setIsLoading(true);
    try {
      // toPdfAuto picks server-side vs legacy based on USE_PDF_SERVER (constants.js).
      await toPdfAuto({
          container: ".pdf-capture",
          filename: `quote-${quoteId || "document"}`,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-modal-dialog" onClick={(e) => e.stopPropagation()}>
        {/*<h2>{title}</h2>*/}
        <div className="modal-body">
          {children}
        </div>
       
        <div className="toolbar">
            <button className={`toolbar-button`} onClick={onClose}>Close</button>
            <button
                className={`toolbar-button ${isLoading ? "loading" : ""}`}
                onClick={handlePdfDownload}
                disabled={isLoading}
            >
            {isLoading ? (
                <span className="spinner"></span>
            ) : (
                "📄 PDF" //PDF----
            )}
            </button>
            <button className={`toolbar-button`}  onClick={() => handleSendEmail(true)} disabled={!isViewDetailsVisible} >
            ✉️ Email
          </button>
        </div>
       
      </div>
      {showEmailDialog && (
            <EmailDialog
              simplePdf={false}
              isOpen={showEmailDialog}
              onClose={() => setShowEmailDialog(false)}
              isSending={isSending}
              setIsSending={setIsSending}
              container=".pdf-capture"         // optional, default is ".view-details"
              filename= "document"
              /* subject/message intentionally not set so EmailDialog loads
                 default_subject/default_message from Mailer Settings. */
            />
            )}   
    </div>
  );
};

export default ModalDialog;
